import { MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { TranslateService } from '@ngx-translate/core';
var UpdateAssigneeModalComponent = /** @class */ (function () {
    function UpdateAssigneeModalComponent(matDialogRef, translateService, customMessageService, data) {
        this.matDialogRef = matDialogRef;
        this.translateService = translateService;
        this.customMessageService = customMessageService;
        this.data = data;
        this.assignee = null;
        this.pendencyId = '';
        this.assignee = this.data.assignee;
        this.pendencyId = this.data.id;
    }
    UpdateAssigneeModalComponent.prototype.closeModal = function () {
        this.matDialogRef.close();
    };
    UpdateAssigneeModalComponent.prototype.closeDialogEvent = function (event) {
        if (!event.detail) {
            this.closeModal();
            return;
        }
        var pendency = event.detail.pendency;
        if (pendency && pendency.assignee) {
            this.customMessageService.success(this.translateService.instant("MAINTENANCES.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.MESSAGES." + event.detail.message));
        }
        else if (event.detail.error === 'UPDATE_ASSIGNEE_ERROR') {
            this.customMessageService.error(this.translateService.instant("MAINTENANCES.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.MESSAGES." + event.detail.message));
        }
        if (pendency && !pendency.assignee && !event.detail.error) {
            this.customMessageService.success(this.translateService.instant("MAINTENANCES.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.REMOVE_ASSIGNEE_MODAL." + event.detail.message));
        }
        else if (event.detail.error === 'REMOVE_ASSIGNEE_ERROR') {
            this.customMessageService.error(this.translateService.instant("MAINTENANCES.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.REMOVE_ASSIGNEE_MODAL." + event.detail.message));
        }
        this.matDialogRef.close(event.detail);
    };
    UpdateAssigneeModalComponent.prototype.showDialog = function () {
        var dialogElement = this.matDialogRef;
        if (this.matDialogRef._containerInstance) {
            var containerDiv = dialogElement._containerInstance._elementRef.nativeElement;
            containerDiv.style.opacity = 1;
            containerDiv.style.transition = 'opacity 0.2s';
            var backdrop = document.querySelector('.cdk-overlay-backdrop');
            if (backdrop) {
                backdrop.style.display = 'block';
            }
        }
    };
    UpdateAssigneeModalComponent.prototype.hideDialog = function () {
        var dialogElement = this.matDialogRef;
        if (this.matDialogRef._containerInstance) {
            var containerDiv = dialogElement._containerInstance._elementRef.nativeElement;
            containerDiv.style.opacity = 0;
            containerDiv.style.transition = 'opacity 0.2s';
            var backdrop = document.querySelector('.cdk-overlay-backdrop');
            if (backdrop) {
                backdrop.style.display = 'none';
            }
        }
    };
    return UpdateAssigneeModalComponent;
}());
export { UpdateAssigneeModalComponent };
